module.exports = __webpack_public_path__ + "img/lordsmobile_guide_fr.e930ab1.png";